import React from 'react';

const PageHero = ({ eyebrow, title, description, image, tint = 'from-[#0b1a2e]/85 via-[#0b1a2e]/65 to-[#0f5c3d]/55' }) => (
  <section className="relative overflow-hidden">
    <div className="absolute inset-0">
      <img src={image} alt={title} className="w-full h-full object-cover" />
      <div className={`absolute inset-0 bg-gradient-to-br ${tint}`} />
    </div>
    <div className="relative max-w-7xl mx-auto px-6 lg:px-8 py-20 lg:py-32 text-white">
      {eyebrow && (
        <span className="inline-block text-[11px] font-semibold tracking-[0.3em] uppercase text-emerald-300">
          {eyebrow}
        </span>
      )}
      <h1
        className="mt-4 text-5xl md:text-6xl lg:text-7xl leading-[1.02] max-w-4xl"
        style={{ fontFamily: 'Cormorant Garamond, serif', fontWeight: 500 }}
      >
        {title}
      </h1>
      {description && (
        <p className="mt-6 max-w-2xl text-white/85 leading-relaxed text-base lg:text-lg">
          {description}
        </p>
      )}
    </div>
  </section>
);

export default PageHero;
